import roundFilter from "./round";
import numberFilter from "./number";
import currencyFilter from "./currency";
import momentFilter from "./moment";
import truncateFilter from "./truncate";

export default {
  install(Vue) {
    Vue.filter("round", roundFilter);
    Vue.filter("number", numberFilter);
    Vue.filter("currency", currencyFilter);
    Vue.filter("moment", momentFilter);
    Vue.filter("truncate", truncateFilter);
  },
};
